<template id="view-reception-channels">
  <div class="container-fluid">
    <div class="row top-row">
      <div class="col-12">
        <h3>Tipos de Formato</h3>
      </div>
    </div>
    <div class="row">
      <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-8 offset-xl-2">
        <ejs-grid
          ref="gridObj"
          class="r-space"
          :actionBegin="onActionBegin"
          :actionComplete="onActionComplete"
          :toolbar="customToolbar"
          :toolbarClick="toolbar_click"
          :dataSource="gridData"
          locale="es-CO"
          :query="query"
          :allowSorting="true"
          :allowSelection="true"
          :allowExcelExport="true"
          :allowFiltering="true"
          :selectionSettings="selectionSettings"
          :allowPaging="true"
          :allowGrouping="false"
          :pageSettings="pageSettings"
          :editSettings="editSettings"
          :filterSettings="filterSettings"
        >
          <e-columns>
            <e-column
              field="id"
              headerText="Id Papirus"
              textAlign="Right"
              :width="90"
              :minWidth="90"
              clipMode="Clip"
              :isPrimaryKey="true"
              :visible="false"
              defaultValue="0"
            ></e-column>
            <e-column
              field="description"
              headerText="Descripción"
              :allowFiltering="true"
              :width="200"
              :minWidth="200"
              clipMode="EllipsisWithTooltip"
              :required="true"
            ></e-column>
            <e-column
              field="isActive"
              headerText="Activo"
              :allowFiltering="false"
              :width="90"
              clipMode="EllipsisWithTooltip"
              :required="true"
              editType="booleanedit"
              displayAsCheckBox="true"
              :allowEditing="canDelete"
            ></e-column>
          </e-columns>
        </ejs-grid>
      </div>
    </div>
  </div>
</template>

<script>
export const FormatTypesColumns = {
  COL_ID: 0,
  COL_DESCRIPTION: 1,
  COL_IS_ACTIVE: 2
};

/*Imports de VueJS*/
import Vue from "vue";
import PermissionMixin from "../../mixins/PermissionMixin";
import ToastMixin from "../../mixins/ToastMixin";
import CultureMixin from "../../mixins/CultureMixin";

/*Imports de Syncfusion*/
import { Browser } from "@syncfusion/ej2-base";
import { ButtonPlugin } from "@syncfusion/ej2-vue-buttons";
import { TooltipPlugin, Tooltip } from "@syncfusion/ej2-vue-popups";
import {
  GridPlugin,
  Edit,
  Filter,
  Group,
  Page,
  Selection,
  CommandColumn,
  Toolbar,
  Sort,
  ExcelExport
} from "@syncfusion/ej2-vue-grids";

Vue.use(GridPlugin);
Vue.use(ButtonPlugin);
Vue.use(TooltipPlugin);

export default Vue.extend({
  name: "FormatTypes",
  props: {},
  components: {},
  mixins: [PermissionMixin, ToastMixin, CultureMixin],
  created() {},
  async mounted() {
    this.$parent.showLoading();
    await this.$store.dispatch("formatTypes/getFormatTypes", null, {
      root: true
    });
    this.gridData = this.formatTypesList;
    this.$parent.hideLoading(500);
  },
  async beforeDestroy() {
    //   await this.$store.dispatch("formatTypes/clearFormatTypes");
  },
  updated() {
    this.gridData = this.formatTypesList;
    this.$refs.gridObj.ej2Instances.dataSource = this.gridData;
    this.$refs.gridObj.ej2Instances.refresh();
  },
  computed: {
    formatTypesList() {
      return this.$store.getters["formatTypes/allFormatTypes"];
    },
    customToolbar() {
      var canCreate = this.hasPermission("CanCreate");
      var canEdit = this.hasPermission("CanEdit");
      var canDelete = this.hasPermission("CanDelete");
      var canExport = this.hasPermission("CanExport");
      var toolbar = [];

      if (canCreate) toolbar.push("Add");
      if (canEdit) toolbar.push("Edit");
      if (canDelete) toolbar.push("Delete");
      toolbar.push("Update");
      toolbar.push("Cancel");
      if (canExport) toolbar.push("ExcelExport");
      toolbar.push({
        text: "Recargar",
        tooltipText: "Recargar Infromación",
        prefixIcon: "e-reload",
        id: "reloadTool"
      });
      return toolbar;
    },
    editSettings() {
      var canCreate = this.hasPermission("CanCreate");
      var canEdit = this.hasPermission("CanEdit");
      var canDelete = this.hasPermission("CanDelete");

      return {
        showDeleteConfirmDialog: true,
        allowEditing: canEdit,
        allowEditOnDblClick: false,
        allowAdding: canCreate,
        allowDeleting: canDelete,
        mode: "Normal"
      };
    },
    canDelete() {
      if (!this.hasPermission("CanDelete")) {
        return false;
      }
      return true;
    }
  },

  data() {
    return {
      /* Datos del Grid */
      gridData: {},
      toolTip: "",
      pageSettings: { pageCount: 5, pageSize: 10 },
      filterSettings: {
        mode: "Immediate",
        immediatemodedelay: 0,
        type: Browser.isDevice ? "Menu" : "FilterBar",
        columns: [],
        ignoreAccent: true
      },
      filter: { type: "CheckBox" },
      selectionSettings: { persistSelection: true },
      query: "",
      customAttributes: { class: "check" }
    };
  },
  provide: {
    grid: [
      Edit,
      Group,
      Sort,
      Filter,
      Page,
      Selection,
      CommandColumn,
      Toolbar,
      ExcelExport,
      Tooltip
    ]
  },
  methods: {
    async onActionBegin(args) {
      if (args.requestType === "filtering") {
        if (args.columns && args.columns.length) {
          args.columns.forEach((col) => {
            // if (
            //   col.field == "description" ||
            //   col.field == "isActive"
            // ) {
            col.operator = "contains"; // set the “contains” operator for the ‘CustomerID’ column
            // }
          });
        }
      }

      if (args.requestType === "refresh") {
        this.$refs.gridObj.showSpinner();
      }

      if (args.action === "add" && args.requestType === "save") {
        if (this.validateData(args.data)) {
          await this.addclick(args.data);
        } else {
          args.cancel = true;
          return;
        }
      }

      if (args.action === "edit" && args.requestType === "save") {
        if (this.validateData(args.data)) {
          await this.editclick(args.data);
        } else {
          args.cancel = true;
          return;
        }
      }

      if (args.requestType === "delete") {
        await this.InactivateRow(args.data[0]);
        args.cancel = true;
      }
    },
    onActionComplete: function (args) {
      if (args.requestType === "refresh") {
        this.$refs.gridObj.hideSpinner();
      }
    },

    async toolbar_click(args) {
      if (args.item.id.includes("excelexport")) {
        this.exportTool_click();
      }

      if (args.item.id === "reloadTool") {
        await this.reloadTool_click();
      }
    },
    exportTool_click() {
      let hora = new Date().toISOString().slice(0, 10);
      let fName = "TiposDeFormatos" + hora + ".xlsx";
      let exportProps = {
        fileName: fName,
        includeHiddenColumn: false
      };

      this.$refs.gridObj.excelExport(exportProps);
    },
    async reloadTool_click() {
      try {
        this.$parent.showLoading();
        await this.$store.dispatch("formatTypes/getFormatTypes");
        this.gridData = this.formatTypesList;
        this.$parent.hideLoading(500);
      } catch (error) {
        this.showToast("Error", "Error cargando los Tipos de Formatos!", 200);
        this.$parent.hideLoading(500);
      }
    },
    async addclick(data) {
      try {
        this.$parent.showLoading();
        var localData = JSON.parse(JSON.stringify(data));
        localData.isActive = true;

        await this.$store.dispatch("formatTypes/createFormatType", localData);
        this.showToast("Confirmación", "Registro Creado!", 2000);
        this.$parent.hideLoading(500);
      } catch (error) {
        this.$parent.hideLoading(500);
        this.showToast(
          "Error!",
          "Ocurrió un error al ejecutar la operación",
          2000
        );
      }
      await this.reloadTool_click();
    },
    async editclick(data) {
      try {
        this.$parent.showLoading();
        var localData = JSON.parse(JSON.stringify(data));
        await this.$store.dispatch("formatTypes/updateFormatType", {
          id: localData.id,
          formatType: localData
        });
        this.$parent.hideLoading(500);
        this.showToast("Confirmación", "Registro Actualizado", 2000);
      } catch (error) {
        this.$parent.hideLoading(500);
        this.showToast(
          "Error!",
          "Ocurrió un error al ejecutar la operación",
          2000
        );
      }
      await this.reloadTool_click();
    },
    async InactivateRow(data) {
      try {
        this.$parent.showLoading();
        var localData = JSON.parse(JSON.stringify(data));
        localData.isActive = false;

        await this.$store.dispatch("formatTypes/updateFormatType", {
          id: localData.id,
          formatType: localData
        });
        this.$parent.hideLoading(500);
        this.showToast(
          "Confirmación",
          `Tipo de Formato ${localData.description} Desactivado`,
          2000
        );
      } catch (error) {
        this.$parent.hideLoading(500);
        this.showToast(
          "Error!",
          "Ocurrió un error al ejecutar la operación",
          2000
        );
      }
      await this.reloadTool_click();
    },
    validateData(data) {
      if (
        data.description === undefined ||
        data.description.trim().length === 0
      ) {
        this.showToast("Invalido!", "Debe digitar una descripción", 2000);
        return false;
      }

      return this.validateDuplicate(data);
    },
    validateDuplicate(data) {
      var listFormatTypes = this.formatTypesList;
      var listado = listFormatTypes.filter((u) => u.id !== data.id);

      if (
        data.description.length > 0 &&
        listado.find(
          (element) =>
            element.description.toUpperCase().trim() ===
            data.description.toUpperCase().trim()
        )
      ) {
        this.showToast(
          "Invalido!",
          "Ya existe un Tipo de Formato con esa descripción",
          2000
        );
        return false;
      }
      return true;
    }
  }
});
</script>
<style>
@import url(../../../node_modules/@syncfusion/ej2-base/styles/fabric.css);
@import url(../../../node_modules/@syncfusion/ej2-vue-notifications/styles/fabric.css);
@import url(../../../node_modules/@syncfusion/ej2-vue-buttons/styles/fabric.css);
@import url(../../../node_modules/@syncfusion/ej2-vue-grids/styles/fabric.css);
@import url(../../../node_modules/@syncfusion/ej2-vue-buttons/styles/fabric.css);
@import url(../../../node_modules/@syncfusion/ej2-vue-inputs/styles/fabric.css);
@import url(../../../node_modules/@syncfusion/ej2-dropdowns/styles/fabric.css);
@import url(../../../node_modules/@syncfusion/ej2-vue-popups/styles/fabric.css);
@import url(../../../node_modules/@syncfusion/ej2-vue-navigations/styles/fabric.css);
@import url(../../../node_modules/vue-loading-overlay/dist/vue-loading.css);

.e-alert-dialog.e-dialog.e-popup,
.e-confirm-dialog.e-dialog.e-popup {
  margin: auto !important;
}

.e-grid .e-new.e-icons:before,
.e-grid-menu .e-new.e-icons:before {
  content: "\e823";
}

.e-grid .e-view.e-icons:before,
.e-grid-menu .e-view.e-icons:before {
  content: "\e609";
}

.e-icon-dlg-close.e-icons:before,
.e-icon-dlg-close.e-icons:before {
  content: "\ea7f";
}

.e-grid .e-reload.e-icons:before,
.e-grid-menu .e-reload.e-icons:before {
  content: "\e218";
}

.datepicker-panel {
  float: right;
  margin-right: 20px;
}
.datepicker-panel-group {
  display: flex;
}
.content-wrapper {
  width: 100%;
  margin: 15px auto;
  min-width: 185px;
}
@media only screen and (max-width: 480px) {
  .content-wrapper {
    width: 92%;
  }
}
.e-add-icon {
  background-repeat: no-repeat;
  /* background-image: url('../assets/Plus.png'); */
}

.e-grid .e-pagerexternalmsg {
  display: none;
}
</style>
